// extracted by mini-css-extract-plugin
module.exports =  {"element":"a10a3f92e9--element--RV4UP","primary":"a10a3f92e9--primary--m4YSw","size-s":"a10a3f92e9--size-s--MQwrR","size-l":"a10a3f92e9--size-l--yX4Rz"};